import { RESERVATION_CHECK } from '^/constants/routes';

export const NAVIGATION_MENU = [
  {
    name: '예약 조회하기',
    url: RESERVATION_CHECK,
  },
];
